export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              APP下载
            </h2>
            <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
              下载番茄影视大全APP，随时随地畅享高清追剧体验。支持离线缓存、弹幕互动、定时关闭等专属功能，追剧更自由。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-lg whitespace-nowrap text-center text-sm flex items-center justify-center gap-2 cursor-pointer hover:bg-background-100 transition-colors"
              >
                <i className="ri-apple-fill text-lg"></i>iOS 版下载
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-background-50/90 text-primary-600 font-medium rounded-lg whitespace-nowrap text-center text-sm flex items-center justify-center gap-2 cursor-pointer hover:bg-background-100 transition-colors"
              >
                <i className="ri-android-fill text-lg"></i>Android 版下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-56 bg-background-50/20 rounded-2xl border border-background-50/30 flex items-center justify-center">
              <div className="text-center text-background-50/80">
                <i className="ri-smartphone-line text-4xl mb-2 block"></i>
                <span className="text-xs">扫码下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}